import { registerPlugin } from '@capacitor/core';

/**
 * Custom plugin for emitting system font size from Android and iOS to Angular
 */
const ZoomPlugin = registerPlugin<IZoomPlugin>('Zoom');

export interface IZoomPlugin {
    getInitialScale(): Promise<{ scaleFactor: number }>;
}

export default ZoomPlugin;
